export default "__VITE_ASSET__BR25ouh1__"